export default function numberLimiter(value: number, maxChars = 3) {
    if (value.toString().length > maxChars) {
        return `${"9".repeat(maxChars)}+`;
    }

    return value;
}
